import { useMutation, useQuery } from '@tanstack/react-query'
import { v4 as generate_uuid } from 'uuid'

import { useToast } from '@/components/ui/use-toast'
import queryClient from '@/queryClient'
import MUTATION_KEYS from './mutationKeys'
import QUERY_KEYS from './queryKeys'

// TODO: Should live somewhere else
export type Tool = { id: string; name: string }

let tools: Tool[] = [
  {
    id: 'da4772a3-d301-4c9b-8a1e-9c0f0c8d1a7b',
    name: 'Cordless Drill',
  },
  {
    id: 'b1fbbac6-5c3e-4d5b-9c3e-2f0c8d1a7b8c',
    name: 'Hammer',
  },
  {
    id: '3d1c165b-801c-4b5c-b5f7-67c4278e3579',
    name: 'Glue',
  },
]

export const useListToolsQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.TOOLS],
    queryFn: async () => {
      return Promise.resolve(tools)
    },
  })
}

export const useCreateTool = () => {
  const { toast } = useToast()
  return useMutation({
    mutationKey: [MUTATION_KEYS.CREATE_TOOL],
    mutationFn: async ({ name }: { name: string }) => {
      return Promise.resolve({ id: generate_uuid(), name })
    },
    onSuccess: (newTool) => {
      queryClient.setQueriesData(
        {
          queryKey: [QUERY_KEYS.TOOLS],
        },
        (tools: Tool[] | undefined = []) => {
          return [...tools, newTool]
        },
      )
    },
    onError: (error) => {
      console.log(error)
      toast({
        title: 'Error',
        description: 'Unable to add tool',
        variant: 'destructive',
      })
    },
  })
}

export const useUpdateTool = () => {
  const { toast } = useToast()
  return useMutation({
    mutationKey: [MUTATION_KEYS.UPDATE_TOOL],
    mutationFn: async ({ toolId, name }: { toolId: string; name: string }) => {
      return Promise.resolve({ toolId, name })
    },
    onSuccess: ({ toolId, name }) => {
      queryClient.setQueriesData(
        {
          queryKey: [QUERY_KEYS.TOOLS],
        },
        (tools: Tool[] | undefined) => {
          if (tools) {
            return tools.map((t) => {
              if (t.id === toolId) {
                return { id: t.id, name }
              }
              return t
            })
          }
          return tools
        },
      )
    },
    onError: (error) => {
      console.log(error)
      toast({
        title: 'Error',
        description: 'Unable to rename tool',
        variant: 'destructive',
      })
    },
  })
}

export const useDeleteTool = () => {
  const { toast } = useToast()
  return useMutation({
    mutationKey: [MUTATION_KEYS.DELETE_TOOL],
    mutationFn: async ({ toolId }: { toolId: string }) => {
      return Promise.resolve({ toolId })
    },
    onSuccess: ({ toolId }) => {
      queryClient.setQueriesData(
        {
          queryKey: [QUERY_KEYS.TOOLS],
        },
        (tools: Tool[] | undefined) => {
          if (tools) {
            return tools.filter((t) => t.id !== toolId)
          }
          return tools
        },
      )
    },
    onError: (error) => {
      console.log(error)
      toast({
        title: 'Error',
        description: 'Unable to delete tool',
        variant: 'destructive',
      })
    },
  })
}
